import React from 'react';

import style from './home.module.scss';

import { Banner } from './banner';
import { Intro } from './intro';
import { Why } from './why';
import { Culture } from './culture';

export const Home = () => {
    return (
        <div className={style.home}>
            <Banner></Banner>
            <Intro></Intro>
            <Why></Why>
            <Culture></Culture>
        </div>
    );
};
